export default {
  header: '',
  item: '<label class="{{cssClasses.label}}">\n  <input type="checkbox"\n         class="{{cssClasses.checkbox}}"\n         value="{{value}}"\n         {{#isRefined}}checked{{/isRefined}} />\n      {{{highlighted}}}\n  <span class="{{cssClasses.count}}">{{#helpers.formatNumber}}{{count}}{{/helpers.formatNumber}}</span>\n</label>',
  footer: ''
};


//////////////////
// WEBPACK FOOTER
// /Applications/MAMP/htdocs/newton/wp-content/themes/newton/node_modules/instantsearch.js/es/widgets/refinement-list/defaultTemplates.js
// module id = 665
// module chunks = 0